import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';

import ReportingComponent from '../components/reporting/ReportingComponent';

const Reporting = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1>{t('reporting.name')}</h1>
      <div className='mt-4'>
        <ReportingComponent />
      </div>
    </Fragment>
  );
};

export default Reporting;
